import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Avatar } from '../../Avatar/Avatar.es.js';
import { Icon } from '../../Icon/Icon.es.js';
import { Menu } from '../../Menu/Menu.es.js';
import { SidenavContext } from '../Sidenav.Context/Sidenav.Context.es.js';
import { SidenavItemTooltip } from '../Sidenav.Item/Sidenav.Item.Tooltip.es.js';

const SidenavUserMenu = ({ firstName, lastName, children })=>{
    const { variant } = useContext(SidenavContext);
    const name = useMemo(()=>`${firstName} ${lastName}`, [
        firstName,
        lastName
    ]);
    const initials = useMemo(()=>firstName.charAt(0) + lastName.charAt(0), [
        firstName,
        lastName
    ]);
    const menuTheme = useMemo(()=>{
        return variant === 'dark' ? 'dark' : 'light';
    }, [
        variant
    ]);
    return jsxs(Menu, {
        className: "cb-sidenav-user-menu",
        theme: menuTheme,
        children: [
            jsx(Menu.Button, {
                className: "button",
                children: ({ open })=>jsx(SidenavItemTooltip, {
                        content: name,
                        children: jsx("span", {
                            className: classNames('button-wrapper', {
                                open
                            }),
                            children: jsxs("span", {
                                className: "inner",
                                children: [
                                    jsx(Avatar, {
                                        className: "avatar",
                                        size: "sm",
                                        children: initials
                                    }),
                                    jsx("span", {
                                        className: "label",
                                        children: name
                                    }),
                                    open ? jsx(Icon.Gradient, {
                                        className: "menu-icon",
                                        name: "ChevronUpSolid",
                                        size: 20,
                                        variant: "BluePurple"
                                    }) : jsx(Icon, {
                                        className: "menu-icon",
                                        name: "ChevronUpSolid",
                                        size: 20
                                    })
                                ]
                            })
                        })
                    })
            }),
            children
        ]
    });
};
SidenavUserMenu.displayName = 'Sidenav.UserMenu';

export { SidenavUserMenu };
//# sourceMappingURL=Sidenav.UserMenu.es.js.map
